
import classNames from 'classnames';

import type { GridTableHeaderItem } from '@uikit';
import { GridTable } from '@uikit';

import type { AutoLayerStoryReward } from './data';

interface AutoLayerStoryRewardTableProps {
  data: AutoLayerStoryReward[];
  className?: string;
}

const tableHeader: GridTableHeaderItem<AutoLayerStoryReward>[] = [
  {
    label: 'Placement',
    name: 'placement',
    bodyCellClassName:
      'max-lg:flex-wrap max-lg:gap-1 max-lg:items-center max-lg:justify-between max-lg:text-lg max-lg:bg-[linear-gradient(90deg,#02184F_0%,#1337A0_40%,#8750F5_80%,#E67BCE_100%)] max-lg:flex max-lg:justify-between max-lg:text-neutral-50 max-lg:py-2 max-lg:py-2',
    render: ({ item, headerItem }) => {
      return (
        <>
          <span className="font-medium lg:hidden">{headerItem.label}</span>
          <span>{item.placement}</span>
        </>
      );
    },
  },
  {
    label: '% of Prize Pool',
    name: 'prizePool',
    bodyCellClassName: 'max-lg:flex max-lg:flex-col max-lg:gap-1',
    render: ({ item, headerItem }) => {
      return (
        <>
          <span className="lg:hidden font-medium text-[#525252]">{headerItem.label}</span>
          <span className="max-lg:text-xl">{item.prizePool}</span>
        </>
      );
    },
  },
  {
    label: '$200,000 in Rewards',
    name: 'reward',
    bodyCellClassName: 'max-lg:flex max-lg:flex-col max-lg:gap-1',
    render: ({ item, headerItem }) => {
      return (
        <>
          <span className="lg:hidden font-medium text-[#525252]">{headerItem.label}</span>
          <span className="max-lg:text-xl">{item.reward}</span>
        </>
      );
    },
  },
  {
    label: 'Win a $50-250 IDO Allocation',
    name: 'allocation',
    bodyCellClassName: 'max-lg:flex max-lg:flex-col max-lg:gap-1',
    render: ({ item, headerItem }) => {
      return (
        <>
          <span className="lg:hidden font-medium text-[#525252]">{headerItem.label}</span>
          <span className="max-lg:text-xl">{item.allocation}</span>
        </>
      );
    },
  },
];

const AutoLayerStoryRewardTable = ({ data, className }: AutoLayerStoryRewardTableProps) => {
  return (
    <GridTable
      headCellClassName="text-center"
      headRowClassName="max-lg:hidden py-2 font-medium text-neutral-50 text-2xl [&>*]:border-r-transparent bg-[linear-gradient(90deg,#02184F_0%,#1337A0_40%,#8750F5_80%,#E67BCE_100%)]"
      bodyRowClassName="min-h-14 max-lg:flex max-lg:rounded-2xl max-lg:bg-neutral-50 max-lg:shadow-card max-lg:flex-col lg:border-b"
      cellClassName="lg:px-2"
      rowClassName="max-lg:pb-4 max-lg:gap-4 max-lg:overflow-hidden lg:px-2 items-center grid-cols-[0.8fr_0.8fr_1fr_1.5fr] first:border-none last:border-none border-[#8AA1F2] lg:[&>*]:border-r last:[&>*]:border-none [&>*]:border-[#8AA1F2]"
      bodyCellClassName="lg:h-full max-lg:w-full lg:flex lg:items-center lg:justify-center max-lg:px-4"
      className={classNames(
        'max-lg:flex max-lg:gap-4 max-lg:flex-col lg:rounded-2xl lg:bg-neutral-50 lg:shadow-card lg:text-center lg:overflow-hidden',
        className,
      )}
      header={tableHeader}
      data={data}
    />
  );
};

export default AutoLayerStoryRewardTable;
